import { createFileRoute } from '@tanstack/react-router';
import { PurgePage } from '../../../features/purge/purge-page.tsx';
import { guardSection } from '../../../shell/guard.ts';

// Owner admin: purge text pasted by mistake (T37).
export const Route = createFileRoute('/_authed/admin/purge')({
  beforeLoad: guardSection('/admin'),
  component: PurgePage,
});
